import React from 'react';

import windowResize from './windowResize.png';
import maximize from './maximize.png';
import minimize from './minimize.png';
import computerBig from './computerBig.png';
import computerSmall from './computerSmall.png';
import myComputer from './myComputer.png';
import showcaseIcon from './showcaseIcon.png';
import doomIcon from './doomIcon.png';
import volumeOn from './volumeOn.png';
import volumeOff from './volumeOff.png';
import windowGameIcon from './windowGameIcon.png';
import windowExplorerIcon from './windowExplorerIcon.png';
import windowsStartIcon from './windowsStartIcon.png';
import close from './close.png';
import marioIcon from './marioIcon.png';
import pacmanIcon from './pacmanIcon.png';
import quakeIcon from './quakeIcon.png';
import tetrisIcon from './tetrisIcon.png';
import tronIcon from './tronIcon.png';
// Apple-style app icons (all under portfolio-inner-site/src/assets/icons/)
import safariIconAsset from './safariIcon.png';
import calendarIconAsset from './calendarIcon.png';
import mailIconAsset from './mailIcon.png';
import linkedinIconAsset from './linkedinIcon.png';
import githubIconAsset from './githubIcon.png';
import folderIconAsset from './folderIcon.png';
import cursorIconAsset from './cursorIcon.png';
import terminalIconAsset from './terminalIcon.png';
import textEditIconAsset from './textEditIcon.png';
import binIconAsset from './binIcon.png';
import documentIconAsset from './documentIcon.png';
import healthIconAsset from './healthIcon.png';
import pdfIconAsset from './pdfIcon.png';
import appleMusicIconAsset from './appleMusicIcon.png';

const icons = {
    windowResize: windowResize,
    maximize: maximize,
    minimize: minimize,
    computerBig: computerBig,
    computerSmall: computerSmall,
    myComputer: myComputer,
    showcaseIcon: showcaseIcon,
    doomIcon: doomIcon,
    volumeOn: volumeOn,
    volumeOff: volumeOff,
    credits: textEditIconAsset,
    close: close,
    windowGameIcon: windowGameIcon,
    windowExplorerIcon: windowExplorerIcon,
    windowsStartIcon: windowsStartIcon,
    marioIcon: marioIcon,
    pacmanIcon: pacmanIcon,
    quakeIcon: quakeIcon,
    tetrisIcon: tetrisIcon,
    tronIcon: tronIcon,
    // Apple-style dock/desktop icons
    safariIcon: safariIconAsset,
    calendarIcon: calendarIconAsset,
    mailIcon: mailIconAsset,
    linkedinIcon: linkedinIconAsset,
    githubIcon: githubIconAsset,
    folderIcon: folderIconAsset,
    cursorIcon: cursorIconAsset,
    terminalIcon: terminalIconAsset,
    textEditIcon: textEditIconAsset,
    binIcon: binIconAsset,
    documentIcon: documentIconAsset,
    healthIcon: healthIconAsset,
    pdfIcon: pdfIconAsset,
    appleMusicIcon: appleMusicIconAsset,
    gamesIcon: windowGameIcon,
};

export type IconName = keyof typeof icons;

const getIconByName = (
    iconName: IconName
    // @ts-ignore
): React.FC<React.SVGAttributes<SVGElement>> => icons[iconName];

export default getIconByName;
